import React from "react";
import { connect } from 'dva';
import { Descriptions } from 'antd';
import { framework_tool, component_tool, utils_tool } from '@/tool'
import createColumns from './columns'

import ModalPlayer from '../components/modalPlayer'

let { WizContainer, modelUtils } = framework_tool
let { WizCard, WizSpin, WizButton, WizSearchBar, WizDataTable, WizBrowserExport, WizTabs, WizModal } = component_tool
let { Session, getPageData } = utils_tool

const _getValue = (type, key) => {
  const values = {
    switchScreen: {
      0: '否',
      1: '是',
    }
  }
  return values[type][key]
}

class ShortVideoRecord extends WizContainer {
  componentName = 'shortVideoRecord'

  constructor(props) {
    super(props)
    const { history } = props
    let detailInfo = {};
    if (history.location && history.location.pathname === '/shortVideo/record') {
      if (history.location && history.location.record) {
        detailInfo = history.location.record
        Session.set('detailInfo', detailInfo)
      } else {
        detailInfo = Session.get('detailInfo') || {}
      }
    }
    this.detailInfo = detailInfo
    this.commentFilters = {}
    this.agreeFilters = {}
    this.lookFilters = {}
    this.shareFilters = {}
    this.collectFilters = {}
    this.commentNum = detailInfo.commentNum || undefined
    this.agreeNum = detailInfo.agreeNum || undefined
    this.lookNum = detailInfo.lookNum || undefined
    this.shareNum = detailInfo.shareNum || undefined
    this.collectNum = detailInfo.collectNum || undefined
    this.state = {
      shortVideoId: detailInfo.id,
      commentNum: detailInfo.commentNum || 0,
      agreeNum: detailInfo.agreeNum || 0,
      lookNum: detailInfo.lookNum || 0,
      shareNum: detailInfo.shareNum || 0,
      collectNum: detailInfo.collectNum || 0
    }
  }

  _componentDidMount() {
    this._getCommentList();
    this._getAgreeList();
  }

  propsAndStateOnChange = {
    commentPageList: this._commentPageList.bind(this),
    commentListExport: this._commentListExportOver.bind(this),
    agreePageList: this._agreePageList.bind(this),
    agreeListExport: this._agreeListExportOver.bind(this),
    lookPageList: this._lookPageList.bind(this),
    lookListExport: this._lookListExportOver.bind(this),
    sharePageList: this._sharePageList.bind(this),
    shareListExport: this._shareListExportOver.bind(this),
    collectPageList: this._collectPageList.bind(this),
    collectListExport: this._collectListExportOver.bind(this),
  }

  _commentPageList(nextProps, nextState) {
    let { commentPageList } = nextProps
    if (commentPageList['success']) {
      nextState['commentNum'] = commentPageList['data']['total'] || 0
    } else {
      wizNotice.error(commentPageList['msg'] || '获取数据失败，请稍后再试')
    }
    return true
  }

  /**导出评论记录*/
  _commentListExportOver(nextProps, nextState) {
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
        }
      },
      {
        headerName: '评论内容',
        field: 'content',
        width: 40,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '姓名',
        field: 'commentFullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '账号',
        field: 'commentUserName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '任职',
        field: 'userIdentityInfos',
        width: 40,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '评论时间',
        field: 'commentTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '是否屏蔽',
        field: 'switchScreen',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '被回复的评论人',
        field: 'replyFullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '点赞数',
        field: 'agreeNum',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]
    if (nextProps.commentListExport.code === 1) {
      let data = nextProps.commentListExport.data
      let shortVideo = data['shortVideo']
      let list = data['list']

      list && list.forEach(e => {
        e['switchScreen'] = _getValue('switchScreen', e['switchScreen'])
      })

      let labelIds = []
      shortVideo['labelIds'] && shortVideo['labelIds'].length && shortVideo['labelIds'].forEach(item => {
        labelIds.push(item.name)
      })
      shortVideo['labelIds'] = labelIds && labelIds.length > 0 ? labelIds.join(",") : ''

      let str = '标题：' + shortVideo['title'] + '\n'
        + '标签：' + shortVideo['labelIds'] + '\n'
        + '发布人：' + shortVideo['fullName'] + '\n'
        + '发布时间：' + shortVideo['releaseTime']

      WizBrowserExport({
        title: str,
        sheetName: '评论记录信息',
        columns: columnDefs.filter((_, index) => index),
        rows: list,
        filename: '评论记录信息.xlsx',
        titleParams: {
          alignment: { vertical: 'bottom', horizontal: 'left', wrapText: true },
          style: {
            alignment: { vertical: "bottom", horizontal: "left", wrapText: true },
          },
          font: {},
        },
        titleRow: {
          height: 60
        }
      })
      return true;
    } else {
      wizNotice.error('获取导出数据失败')
      return false;
    }
  }

  _agreePageList(nextProps, nextState) {
    let { agreePageList } = nextProps
    if (agreePageList['success']) {
      nextState['agreeNum'] = agreePageList['data']['total'] || 0
      return true;
    } else {
      wizNotice.error(agreePageList['msg'] || '获取数据失败，请稍后再试')
    }
    return true
  }

  /**导出点赞记录*/
  _agreeListExportOver(nextProps, nextState) {
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
        }
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '任职',
        field: 'userIdentityInfos',
        width: 40,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '点赞时间',
        field: 'operateTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]
    if (nextProps.agreeListExport.code === 1) {
      let data = nextProps.agreeListExport.data
      let shortVideo = data['shortVideo']
      let list = data['list']

      let labelIds = []
      shortVideo['labelIds'] && shortVideo['labelIds'].length && shortVideo['labelIds'].forEach(item => {
        labelIds.push(item.name)
      })
      shortVideo['labelIds'] = labelIds && labelIds.length > 0 ? labelIds.join(",") : ''

      let str = '标题：' + shortVideo['title'] + '\n'
        + '标签：' + shortVideo['labelIds'] + '\n'
        + '发布人：' + shortVideo['fullName'] + '\n'
        + '发布时间：' + shortVideo['releaseTime']

      WizBrowserExport({
        title: str,
        sheetName: '点赞记录信息',
        columns: columnDefs.filter((_, index) => index),
        rows: list,
        filename: '点赞记录信息.xlsx',
        titleParams: {
          alignment: { vertical: 'bottom', horizontal: 'left', wrapText: true },
          style: {
            alignment: { vertical: "bottom", horizontal: "left", wrapText: true },
          },
          font: {},
        },
        titleRow: {
          height: 60
        }
      })
      return true;
    } else {
      wizNotice.error('获取导出数据失败')
      return false;
    }
  }

  _lookPageList(nextProps, nextState) {
    let { lookPageList } = nextProps
    if (lookPageList['success']) {
      nextState['lookNum'] = lookPageList['data']['total'] || 0
      return true;
    } else {
      wizNotice.error(lookPageList['msg'] || '获取数据失败，请稍后再试')
    }
    return true
  }

  /**导出观看记录*/
  _lookListExportOver(nextProps, nextState) {
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
        }
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '任职',
        field: 'userIdentityInfos',
        width: 40,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '观看时间',
        field: 'operateTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]
    if (nextProps.lookListExport.code === 1) {
      let data = nextProps.lookListExport.data

      let shortVideo = data['shortVideo']
      let list = data['list']

      let labelIds = []
      shortVideo['labelIds'] && shortVideo['labelIds'].length && shortVideo['labelIds'].forEach(item => {
        labelIds.push(item.name)
      })
      shortVideo['labelIds'] = labelIds && labelIds.length > 0 ? labelIds.join(",") : ''

      let str = '标题：' + shortVideo['title'] + '\n'
        + '标签：' + shortVideo['labelIds'] + '\n'
        + '发布人：' + shortVideo['fullName'] + '\n'
        + '发布时间：' + shortVideo['releaseTime']

      WizBrowserExport({
        title: str,
        sheetName: '观看记录',
        columns: columnDefs.filter((_, index) => index),
        rows: list,
        filename: '观看记录.xlsx',
        titleParams: {
          alignment: { vertical: 'bottom', horizontal: 'left', wrapText: true },
          style: {
            alignment: { vertical: "bottom", horizontal: "left", wrapText: true },
          },
          font: {},
        },
        titleRow: {
          height: 60
        }
      })
      return true;
    } else {
      wizNotice.error('获取导出数据失败')
      return false;
    }
  }

  _sharePageList(nextProps, nextState) {
    let { sharePageList } = nextProps
    if (sharePageList['success']) {
      nextState['shareNum'] = sharePageList['data']['total'] || 0
      return true;
    } else {
      wizNotice.error(sharePageList['msg'] || '获取数据失败，请稍后再试')
    }
    return true
  }

  /**导出分享记录*/
  _shareListExportOver(nextProps, nextState) {
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
        }
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '任职',
        field: 'userIdentityInfos',
        width: 40,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '分享时间',
        field: 'operateTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '分享平台',
        field: 'sharePlatform',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]
    if (nextProps.shareListExport.code === 1) {
      let data = nextProps.shareListExport.data

      let shortVideo = data['shortVideo']
      let list = data['list']

      let labelIds = []
      shortVideo['labelIds'] && shortVideo['labelIds'].length && shortVideo['labelIds'].forEach(item => {
        labelIds.push(item.name)
      })
      shortVideo['labelIds'] = labelIds && labelIds.length > 0 ? labelIds.join(",") : ''

      let str = '标题：' + shortVideo['title'] + '\n'
        + '标签：' + shortVideo['labelIds'] + '\n'
        + '发布人：' + shortVideo['fullName'] + '\n'
        + '发布时间：' + shortVideo['releaseTime']

      WizBrowserExport({
        title: str,
        sheetName: '分享信息',
        columns: columnDefs.filter((_, index) => index),
        rows: list,
        filename: '分享信息.xlsx',
        titleParams: {
          alignment: { vertical: 'bottom', horizontal: 'left', wrapText: true },
          style: {
            alignment: { vertical: "bottom", horizontal: "left", wrapText: true },
          },
          font: {},
        },
        titleRow: {
          height: 60
        }
      })
      return true;
    } else {
      wizNotice.error('获取导出数据失败')
      return false;
    }
  }

  _collectPageList(nextProps, nextState) {
    let { collectPageList } = nextProps
    if (collectPageList['success']) {
      nextState['collectNum'] = collectPageList['data']['total'] || 0
      return true;
    } else {
      wizNotice.error(collectPageList['msg'] || '获取数据失败，请稍后再试')
    }
    return true
  }

  /**导出收藏记录*/
  _collectListExportOver(nextProps, nextState) {
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
        }
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '任职',
        field: 'userIdentityInfos',
        width: 40,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '收藏时间',
        field: 'operateTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]
    if (nextProps.collectListExport.code === 1) {
      let data = nextProps.collectListExport.data

      let shortVideo = data['shortVideo']
      let list = data['list']

      let labelIds = []
      shortVideo['labelIds'] && shortVideo['labelIds'].length && shortVideo['labelIds'].forEach(item => {
        labelIds.push(item.name)
      })
      shortVideo['labelIds'] = labelIds && labelIds.length > 0 ? labelIds.join(",") : ''

      let str = '标题：' + shortVideo['title'] + '\n'
        + '标签：' + shortVideo['labelIds'] + '\n'
        + '发布人：' + shortVideo['fullName'] + '\n'
        + '发布时间：' + shortVideo['releaseTime']


      WizBrowserExport({
        title: str,
        sheetName: '收藏信息',
        columns: columnDefs.filter((_, index) => index),
        rows: list,
        filename: '收藏信息.xlsx',
        titleParams: {
          alignment: { vertical: 'bottom', horizontal: 'left', wrapText: true },
          style: {
            alignment: { vertical: "bottom", horizontal: "left", wrapText: true },
          },
          font: {},
        },
        titleRow: {
          height: 60
        }
      })
      return true;
    } else {
      wizNotice.error('获取导出数据失败')
      return false;
    }
  }

  _onChangeScreen = (apiParams, state) => {
    if (apiParams.id) {
      WizModal.confirm({
        title: "注意",
        content: `您确定要${state === 0 ? "启用" : "禁用"}该评论吗？`,
        onOk: () => {
          this.doAction({
            path: "comment/changeScreen",
            payload: {
              key: "comment@changeScreen",
              apiParams,
            },
          });
          this._getCommentList(this.commentFilters)
        },
        onCancel() { },
      });
    }
  };

  changeTab = (e) => {
    if (e === '0') {
      this._getCommentList()
    } else if (e === '1') {
      this._getAgreeList()
    } else if (e === '2') {
      this._getLookRecordList()
    } else if (e === '3') {
      this._getShareRecordList()
    } else if (e === '4') {
      this._getCollectRecordList()
    }
  }

  _getCommentList(apiParams = {}) {
    let { shortVideoId } = this.state
    this.doAction({
      path: 'comment/shortVideoCommentPageList',
      payload: {
        key: 'comment@shortVideoCommentPageList',
        apiParams: {
          shortVideoId: shortVideoId,
          bizType: 60,//短视频
          ...apiParams
        }
      }
    })
  }

  _getAgreeList(apiParams = {}) {
    let { shortVideoId } = this.state
    this.doAction({
      path: 'operateRecord/shortVideoOperatePageList',
      payload: {
        key: 'operateRecord@shortVideoOperatePageList',
        apiParams: {
          shortVideoId: shortVideoId,
          operationType: 1,
          ...apiParams
        }
      }
    })
  }

  _getCommentInfo(apiParams = {}) {
    let { shortVideoId } = this.state
    this.doAction({
      path: 'comment/shortVideoCommentList',
      payload: {
        key: 'comment@shortVideoCommentList',
        apiParams: {
          shortVideoId: shortVideoId,
          bizType: 60,//短视频
          ...apiParams
        }
      }
    })
  }

  _getAgreeInfo(apiParams = {}) {
    let { shortVideoId } = this.state
    this.doAction({
      path: 'operateRecord/shortVideoOperateList',
      payload: {
        key: 'operateRecord@shortVideoOperateList',
        apiParams: {
          shortVideoId: shortVideoId,
          operationType: 1,
          ...apiParams
        }
      }
    })
  }

  _onSelect(keys, rows) {
    this.setState({
      keys,
      rows,
      selectedRows: keys.length
    })
  }

  _getLookRecordList(apiParams = {}) {
    let { shortVideoId } = this.state
    this.doAction({
      path: 'shortVideo/operatePageList',
      payload: {
        key: 'shortVideo@lookPageList',
        apiParams: {
          operateType: 0,
          shortVideoId: shortVideoId,
          ...apiParams
        }
      }
    })
  }

  _getShareRecordList(apiParams = {}) {
    let { shortVideoId } = this.state
    this.doAction({
      path: 'shortVideo/operatePageList',
      payload: {
        key: 'shortVideo@sharePageList',
        apiParams: {
          operateType: 1,
          shortVideoId: shortVideoId,
          ...apiParams
        }
      }
    })
  }

  _getCollectRecordList(apiParams = {}) {
    let { shortVideoId } = this.state
    this.doAction({
      path: 'shortVideo/operatePageList',
      payload: {
        key: 'shortVideo@collectPageList',
        apiParams: {
          operateType: 2,
          shortVideoId: shortVideoId,
          ...apiParams
        }
      }
    })
  }

  _getLookRecordInfo(apiParams = {}) {
    let { shortVideoId } = this.state
    this.doAction({
      path: 'shortVideo/operateList',
      payload: {
        key: 'shortVideo@lookList',
        apiParams: {
          operateType: 0,
          shortVideoId: shortVideoId,
          ...apiParams
        }
      }
    })
  }

  _getShareRecordInfo(apiParams = {}) {
    let { shortVideoId } = this.state
    this.doAction({
      path: 'shortVideo/operateList',
      payload: {
        key: 'shortVideo@shareList',
        apiParams: {
          operateType: 1,
          shortVideoId: shortVideoId,
          ...apiParams
        }
      }
    })
  }

  _getCollectRecordInfo(apiParams = {}) {
    let { shortVideoId } = this.state
    this.doAction({
      path: 'shortVideo/operateList',
      payload: {
        key: 'shortVideo@collectList',
        apiParams: {
          operateType: 2,
          shortVideoId: shortVideoId,
          ...apiParams
        }
      }
    })
  }
  /**
   * 渲染操作按钮 且 进行权限检查
   */
  _renderBtn = (type) => {
    let r = []
    let btns = new Map();
    btns.set('export',
      <WizButton
        key={'btn_' + type}
        title="导出"
        type="export"
        onClick={() => {
          if (type === 'comment') {
            this._getCommentInfo(this.commentFilters)
          }
          if (type === 'agree') {
            this._getAgreeInfo(this.agreeFilters)
          }
          if (type === 'look') {
            this._getLookRecordInfo(this.lookFilters)
          }
          if (type === 'share') {
            this._getShareRecordInfo(this.shareFilters)
          }
          if (type === 'collect') {
            this._getCollectRecordInfo(this.collectFilters)
          }
        }}
        icon="export"
        style={{ marginBottom: 15 }}>导出</WizButton>
    );
    let btnCode = this.getMenuBtn() || [];
    btnCode.map(({ code }) => {
      if (btns.has(code)) {
        r.push(btns.get(code))
      }
    })
    return r
  }

  renderRecordInfo = (type) => {
    let { commentPageList, agreePageList, lookPageList, sharePageList, collectPageList, shortVideoLoading, commentLoading, operateRecordLoading } = this.props
    let columns = createColumns(this, type)
    let loading = shortVideoLoading
    let pageList = commentPageList
    switch (type) {
      case 'comment':
        pageList = commentPageList;
        loading = commentLoading
        break;
      case 'agree':
        pageList = agreePageList;
        loading = operateRecordLoading
        break;
      case 'look':
        pageList = lookPageList;
        break;
      case 'share':
        pageList = sharePageList;
        break;
      case 'collect':
        pageList = collectPageList;
        break;
    }

    let list = getPageData(pageList && pageList.data)
    let searchBarProps = {
      columns,
      onSearch: values => {
        if (type === 'comment') {
          this.commentFilters = values
          this._getCommentList(values)
        }
        if (type === 'agree') {
          this.agreeFilters = values
          this._getAgreeList(values)
        }
        if (type === 'look') {
          this.lookFilters = values
          this._getLookRecordList(values)
        }
        if (type === 'share') {
          this.shareFilters = values
          this._getShareRecordList(values)
        }
        if (type === 'collect') {
          this.collectFilters = values
          this._getCollectRecordList(values)
        }
      }
    }
    let dataTableProps = {
      columns,
      rowKey: 'id',
      dataItems: list,
      isScroll: true,
      onChange: ({ pageNum, pageSize }) => {
        if (type === 'comment') {
          this._getCommentList({ current: pageNum, size: pageSize, ...this.commentFilters })
        }
        if (type === 'agree') {
          this._getAgreeList({ current: pageNum, size: pageSize, ...this.agreeFilters })
        }
        if (type === 'look') {
          this._getLookRecordList({ current: pageNum, size: pageSize, operateType: 0, ...this.lookFilters })
        }
        if (type === 'share') {
          this._getShareRecordList({ current: pageNum, size: pageSize, operateType: 1, ...this.shareFilters })
        }
        if (type === 'collect') {
          this._getCollectRecordList({ current: pageNum, size: pageSize, operateType: 2, ...this.collectFilters })
        }
      },
      onSelect: (keys, rows) => this._onSelect(keys, rows)
    }
    return (
      <WizSpin key={'tab_' + type} tip={'加载中'} spinning={loading}>
        <div className='pagination'>
          <WizSearchBar key="shortVideo_searchBar" type="grid" {...searchBarProps} />
        </div>
        {this._renderBtn(type)}
        <WizDataTable key={'shortVideo_dataTable'} {...dataTableProps} />
        <div className='pagination'>
          <WizDataTable.Pagination key={'shortVideo_pagination'} {...dataTableProps} />
        </div>
      </WizSpin>
    )
  }

  _render() {
    const items = this.detailInfo
    let labelIds = []
    items['labelIds'] && items['labelIds'].length && items['labelIds'].forEach(item => {
      labelIds.push(item.name)
    })
    items['labelNames'] = labelIds && labelIds.length > 0 ? labelIds.join(",") : ''
    let { visible, videoUrl } = this.state
    const modalProps = {
      visible,
      videoUrl,
      setVisible: () => this.setState({ visible: false, videoUrl: '' })
    }
    return (
      <React.Fragment>
        <WizCard title={'基础信息'}>
          <Descriptions column={2} style={{ paddingLeft: 25 }}>
            <Descriptions.Item label='标题'>
              <>
                <span style={{ marginRight: 10 }}>{items.title}</span>
                <WizButton type='primary' shape='round' size='small' onClick={() => this.setState({ visible: true, videoUrl: items.video })} >
                  播放
                </WizButton>
              </>
            </Descriptions.Item>
            <Descriptions.Item label='标签'>{items.labelNames}</Descriptions.Item>
            <Descriptions.Item label='发布人'>{items.fullName}</Descriptions.Item>
            <Descriptions.Item label='发布时间'>{items.releaseTime}</Descriptions.Item>
          </Descriptions>
        </WizCard>

        <WizCard title="记录管理">
          <WizTabs defaultActiveKey="0" onChange={this.changeTab}>
            <WizTabs.TabPane tab={'评论记录(' + (this.state.commentNum || 0) + ')'} key="0">
              {this.renderRecordInfo('comment')}
            </WizTabs.TabPane>
            <WizTabs.TabPane tab={'点赞记录(' + (this.state.agreeNum || 0) + ')'} key="1">
              {this.renderRecordInfo('agree')}
            </WizTabs.TabPane>
            <WizTabs.TabPane tab={'观看记录(' + (this.state.lookNum || 0) + ')'} key="2">
              {this.renderRecordInfo('look')}
            </WizTabs.TabPane>
            <WizTabs.TabPane tab={'分享记录(' + (this.state.shareNum || 0) + ')'} key="3">
              {this.renderRecordInfo('share')}
            </WizTabs.TabPane>
            <WizTabs.TabPane tab={'收藏记录(' + (this.state.collectNum || 0) + ')'} key="4">
              {this.renderRecordInfo('collect')}
            </WizTabs.TabPane>
          </WizTabs>
        </WizCard>
        <ModalPlayer {...modalProps} />
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  let { shortVideo, comment, operateRecord } = state
  const commentChangeScreen = modelUtils.getModelEntity(comment, 'comment@changeScreen');
  const commentPageList = modelUtils.getModelEntity(comment, 'comment@shortVideoCommentPageList');
  const commentListExport = modelUtils.getModelEntity(comment, 'comment@shortVideoCommentList');
  const agreePageList = modelUtils.getModelEntity(operateRecord, 'operateRecord@shortVideoOperatePageList');
  const agreeListExport = modelUtils.getModelEntity(operateRecord, 'operateRecord@shortVideoOperateList');
  const lookPageList = modelUtils.getModelEntity(shortVideo, 'shortVideo@lookPageList');
  const lookListExport = modelUtils.getModelEntity(shortVideo, 'shortVideo@lookList');
  const sharePageList = modelUtils.getModelEntity(shortVideo, 'shortVideo@sharePageList');
  const shareListExport = modelUtils.getModelEntity(shortVideo, 'shortVideo@shareList');
  const collectPageList = modelUtils.getModelEntity(shortVideo, 'shortVideo@collectPageList');
  const collectListExport = modelUtils.getModelEntity(shortVideo, 'shortVideo@collectList');
  const load = modelUtils.getLoadingState(state, ['shortVideo', 'comment', 'operateRecord'])
  return {
    commentChangeScreen,
    commentPageList,
    commentListExport,
    agreePageList,
    agreeListExport,
    lookPageList,
    lookListExport,
    sharePageList,
    shareListExport,
    collectPageList,
    collectListExport,
    ...load
  }
};

export default connect(mapStateToProps)(ShortVideoRecord)
